<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词" suffix-icon="el-icon-search"
                        style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select v-model="form.classId" clearable placeholder="全部" style="width: 120px">
                        <el-option v-for="item in classes" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="系列">
                    <el-select v-model="form.lessonSystemId" clearable placeholder="全部" style="width: 120px">
                        <el-option v-for="item in lessonSystems" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="课程">
                    <el-select v-model="form.lessonId" clearable placeholder="全部" style="width: 120px">
                        <el-option v-for="item in lessons" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否点评">
                    <el-select v-model="form.hasEvaluated" clearable placeholder="全部" style="width: 120px">
                        <el-option label="已点评" :value="true"></el-option>
                        <el-option label="未点评" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学生">
                    <el-select v-model="form.userId" clearable remote filterable placeholder="请输入学生姓名"
                        :remote-method="userSearch" @change="changeLoad()">
                        <el-option v-for="item in students" :key="item.id" :label="item.name" :value="item.id">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.sn }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table :data="tableData" stripe style="width: 100%" @sort-change="handleSortChange">
                <el-table-column min-width="180" label="作品标题">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="view(scope.row.lessonType,scope.row.id)" class="font14">
                            {{ scope.row.title }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column min-width="120" label="学生">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span>{{ scope.row.userName }}</span>
                            <span>{{ scope.row.userSn }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="120" prop="taskName" label="任务">
                </el-table-column>
                <el-table-column min-width="180" label="课程">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span>{{ scope.row.lessonName }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="150" prop="className" label="班级">
                </el-table-column>
                <el-table-column min-width="120" prop="teacherName" label="上课教师">
                </el-table-column>
                <el-table-column min-width="200" label="点评详情" sortable="custom" prop="evaluateScore">
                    <template slot-scope="scope">
                        <template v-if="scope.row.evaluateTime != null">
                            <div class="fx-col fx-center">
                                <span class="fx fx-center">已点评
                                    <el-rate style="display: inline-block" v-model="scope.row.evaluateScore" disabled
                                        show-score text-color="#ff9900">
                                    </el-rate>
                                </span>
                                <p>{{ scope.row.teacherEvaluate }}</p>
                            </div>
                        </template>
                        <template v-else>
                            <span class="text_info">未点评</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column min-width="210" label="时间" sortable="custom1" prop="createTime">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span>提交时间：{{ scope.row.publishTime || scope.row.createTime }}</span>
                            <span v-if="scope.row.evaluateTime != null">
                                评价时间：{{ scope.row.evaluateTime }}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" label="推荐">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.recommendedWorks" active-color="#13ce66" inactive-color="#ff4949"
                            @change="setRecommend(scope.row)" :inactive-valu="0" :active-value="1">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="correct(scope.row)" :underline="false"><i
                                class="iconfont icon-bianji"></i><b>批改</b></el-link>


                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                :current-page="pager.currentPage" :page-size="pager.pageSize" :total="pager.dataTotal"
                @current-change="pageChange">
            </el-pagination>
        </div>


        <el-dialog :title="`快捷评价【${evaluateItem.title}】作品`" :visible.sync="showEvaluate" width="600px">
            <el-form :model="evaluateItem" label-width="70px">
                <el-form-item label="评分">
                    <el-rate v-model="evaluateItem.evaluateScore" style="height: 40px;line-height: 48px"></el-rate>
                </el-form-item>
                <el-form-item label="评语">
                    <el-input v-model="evaluateItem.teacherEvaluate" type="textarea" autocomplete="off"
                        style="width: 450px;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showEvaluate = false">取 消</el-button>
                <el-button type="primary" @click="subEvaluate">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<style scoped>

</style>
<style>

</style>

<script>
    export default {
        components: {},
        props: [
            "attr" // {isSelf, classId, classLessonTaskId, } 小心！如果父页面传入了classLessonTaskId,那么切换班级后，可能会查不到数据，因为这个参数会一直跟着请求
        ],
        data() {
            return {
                isSelf: this.attr && this.attr.isSelf == true, //是否只查询自己教任班级的

                showEdit: false,

                showEvaluate: false,
                evaluateItem: {}, //评价页面
                evaluateIndex: 0,

                form: {
                    keywords: "",
                    lessonSystemId: null,
                    lessonId: null,
                    classLessonTaskId: this.attr ? this.attr.classLessonTaskId : null,
                    classId: this.attr ? this.attr.classId : null,
                    userId: '',
                },
                lessonSystems: [],
                classes: [],
                lessons: [],
                students: [],


                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
            }

        },

        watch: {
            "form": {
                handler: function(newValue, oldValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            },
            "form.lessonSystemId": function() {
                this.loadLessons();
            }
        },

        methods: {
            handleSortChange({
                column,
                prop,
                order
            }) {
                if (prop === 'evaluateScore') {
                    this.sortData(order);
                }
                if (prop === 'createTime') {
                    this.sortData1(order);
                }
            },
            sortData(order) {
                if (order === 'ascending') {
                    this.tableData.sort((a, b) => {
                        if (a.evaluateScore < b.evaluateScore) return -1;
                        if (a.evaluateScore > b.evaluateScore) return 1;
                        return 0;
                    });
                } else if (order === 'descending') {
                    this.tableData.sort((a, b) => {
                        if (a.evaluateScore > b.evaluateScore) return -1;
                        if (a.evaluateScore < b.evaluateScore) return 1;
                        return 0;
                    });
                } else {
                    // Reset sorting
                    this.tableData.sort((a, b) => 0);
                }
            },
            sortData1(order) {
                if (order === 'ascending') {
                    this.tableData.sort((a, b) => {
                        if (a.createTime < b.createTime) return -1;
                        if (a.createTime > b.createTime) return 1;
                        return 0;
                    });
                } else if (order === 'descending') {
                    this.tableData.sort((a, b) => {
                        if (a.createTime > b.createTime) return -1;
                        if (a.createTime < b.createTime) return 1;
                        return 0;
                    });
                } else {
                    // Reset sorting
                    this.tableData.sort((a, b) => 0);
                }
            },

            //把作品设置成推荐
            setRecommend(row) {
                let id = row.id;
                this.$ajaxPost("/work/saveRecommendedWorks", {
                    id: id
                }, (data) => {
                    this.$showSuccess("设置成功");
                })
            },
            userSearch(query) {
                //this.form.keywords = query;
                this.$ajaxPost("/user/list", {
                    form: {
                        isStudent: true,
                        classId: "",
                        keywords: query
                    },
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    this.students = data.result;
                })
            },
            view(lessonType, id) {
                console.log(lessonType);
                this.$goEditCode(lessonType, "mode=workview&id=" + id);
            },
            correct(item) {
                window.openTab("/program/correct?mode=correct&id=" + item.id);
            },
            evaluate(item, index) {
                this.evaluateItem = item;
                this.evaluateIndex = index;
                this.showEvaluate = true;
            },
            subEvaluate() {
                if (!this.evaluateItem.evaluateScore) {
                    this.$showError("请打分后再提交");
                    return;
                }
                this.$ajaxPost("/work/evaluate", {
                    workId: this.evaluateItem.id,
                    score: this.evaluateItem.evaluateScore,
                    content: this.evaluateItem.teacherEvaluate
                }, (data) => {
                    this.$showSuccess("评价成功");
                    this.evaluateItem.evaluateTime = new Date().format("yyyy-MM-dd HH:mm");
                    this.tableData.splice(this.evaluateIndex, 1, {
                        ...this.evaluateItem
                    });
                    this.showEvaluate = false;
                })

            },

            loadData() {
                let url = null;
                if (this.attr && this.attr.isSelf) {
                    url = "/work/listSelfClassTaskWorks";
                } else {
                    url = "/work/listTaskWorks";
                }
                this.$ajaxPost(url, {
                    form: this.form,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },

            loadLessonSystems() {
                this.$ajaxPost("/lessonSystem/list", {
                    form: {
                        enable: true
                    }
                }, (data) => {
                    this.lessonSystems = data.result;
                })
            },
            loadLessons() {
                this.form.lessonId = null;
                if (this.form.lessonSystemId) {
                    this.$ajaxGet("/lesson/listBySystemWithSimpleInfo/" + this.form.lessonSystemId, data => {
                        this.lessons = data.result;
                    })
                } else {
                    this.lessons = [];
                }
            },
            loadClasses() {
                let url = null;
                if (this.isSelf) {
                    url = "/class/listSelf";
                } else {
                    url = "/class/list";
                }
                this.$ajaxPost(url, {
                    form: {
                        enable: true,
                        hasEnable: true
                    }
                }, data => {
                    this.classes = data.result;
                })
            },


        },

        created() {
            this.loadData();
            this.loadClasses();
            this.loadLessonSystems();
        }

    }
</script>
